<div class="ya-typography" (swiperight)="swiperNavigateBack()">
  <ya-subheader [hasContent]="!hasImagePhoto"></ya-subheader>
  <div *ngIf="hasImagePhoto" class="aspect-ratio-box">
    <div class="aspect-ratio-box-inside">
      <div class="aspect-ration-img-box">
        <img class="ya_image image" [src]="imagePhoto" rel="preload" alt="Logo" />
      </div>
    </div>
  </div>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="title-container" [ngClass]="hasImagePhoto? 'title-margin':''">
      <h2 *ngIf="useImageLabel">{{imageLabel}}</h2>
      <ng-container *ngIf="mandatoryPayment">
        <div class="table-info--user">
          <h2>{{tableNumberText}}</h2>
          <h2>, </h2>
          <h2 class="name-user">{{userText}}</h2>
        </div>
      </ng-container>
    </div>
    <div class="inHause-service-item-container">
      <ng-container *ngIf="!mandatoryPayment">
        <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToTableOverview()">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch-voll"></div>
          </div>
          <div class="content-container">
            <h2 class="title">
              <span>{{tableNumberText}}</span>
              <span>, </span>
              <span>{{userText}}</span>
            </h2>
            <div class="table-info-container">
              <span class="info text content-container--subfont" langkey="phInHouseService_Ordered_Items"></span>
              <span class="info text content-container--subfont">{{openItemsText}}</span>
            </div>
            <div class="table-info-container">
              <span class="info text content-container--subfont" langkey="phInHouseService_Open_Bill"></span>
              <span class="info text content-container--subfont">{{openPriceText}}</span>
            </div>
          </div>
          <ng-container *ngIf="readyForPickUpCount$ | async; let readyForPickUpCount">
            <div class="mat-badge" [matBadge]="readyForPickUpCount" matBadgeOverlap="false" matBadgeSize="small"
              matBadgePosition="above after">
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="isLoaded">
        <ng-container *ngIf="isOrderButtonActive">
          <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToMenuGroup()">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bestellen"></div>
            </div>
            <div class="content-container">
              <h2 class="title">{{orderButtonTitle}}</h2>
              <span class="text content-container--subfont">{{orderButtonDescription}}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasPayment && !mandatoryPayment">
          <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToPayment()"
            [ngClass]="isPaymentButtonActive ? '' : 'disable'">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bezahlen"></div>
            </div>
            <div class="content-container">
              <h2 class="title">
                {{payButtonTitle}}
              </h2>
              <span class="text content-container--subfont">{{payButtonDescription}}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasServiceCall">
          <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToServiceCall()">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-serviceruf"></div>
            </div>
            <div class="content-container">
              <h2 class="title">{{serviceCallButtonTitle}}</h2>
              <span class="text content-container--subfont">{{serviceCallButtonDescription}}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="ya-webshop-button-container animate">
      <button a11y_Button mat-flat-button (click)="closeInHouseOrderingAsync()">
        <span langkey="phInHouseOrder_CloseOrdering_Button"></span>
      </button>
    </div>
  </div>
  <div *ngIf="showIOSAppBanner" class="main-banner-container">
    <div class="app-banner">
      <div a11y_Button class="app-banner__remove-btn" (click)="removeBanner(true)">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
      </div>
      <div class="image-container image-container--loaded">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" class="image" />
      </div>
      <div class="app-banner-paragraph">
        <span langkey="phOpenLinkInApp_Text"></span>
      </div>
      <div a11y_Button class="app-banner__open-btn" (click)="openApp()" langkey="phOpenLinkInApp_Action_Open"></div>
    </div>
  </div>
</div>